import { elementAt } from 'rxjs';
import { TituloAbaService } from "../titulo-aba/titulo-aba.service";
import { Component, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { environment } from "../../../environments/environment";
import { Pipe, PipeTransform } from '@angular/core';
@Pipe({ name: 'replaceSpaces' })
export class ReplaceSpacesPipe implements PipeTransform {
  transform(value: string): string {
    return value.replace(/\s+/g, '-');
  }
}

SwiperCore.use([Autoplay, Pagination, Navigation]);
import SwiperCore, {
  Autoplay,
  Pagination,
  Navigation,
  SwiperOptions,
} from "swiper";
import { SwiperComponent } from "swiper/angular";

@Component({
  selector: "app-clover",
  templateUrl: "./clover.component.html",
  styleUrl: "./clover.component.scss",
  encapsulation: ViewEncapsulation.None,
})

export class CloverComponent implements OnInit {
  public env = environment;

  constructor(private tituloAbaService: TituloAbaService) {}

  carouselCards: any[] = [
    {
      text: "<span class='fw-bold font-black'>Bares e Restaurantes</span>",
      img: "icon-food-2.svg",
    },
    {
      text: "<span class='fw-bold font-black'>Varejo</span>",

      img: "icon-money-drawer.svg",
    },
    {
      text: "<span class='fw-bold font-black'>Serviços</span>",
      img: "icon-graphic-2.svg",
    },
    {
      text: "<span class='fw-bold font-black'>Tickets e Eventos</span>",
      img: "icon-ticket-2.svg",
    },
    {
      text: "<span class='fw-bold font-black'>Materiais de Construção</span>",
      img: "icon-construcao.svg",
    },
    {
      text: "<span class='fw-bold font-black'>Estacionamentos</span>",
      img: "icon-car.svg",
    },
    {
      text: "<span class='fw-bold font-black'>Mercados</span>",
      img: "icon-mercado.svg",
    },
  ];
  openIndex: number | null = null;
  bandeiras: string[] = [
    "skytef-cinza.png",
    "thr-cinza.png",
    "gz-cinza.png",
    "maq-cinza.png",
    "pdv-cinza.png",
    "sw-cinza.png",
    "pos-cinza.png",
    "pag-cinza.png",
    "arus-cinza.png",
    "mobility-cinza.png",
  ];
  myConfig = {
    320: {
      slidesPerView: 1,
      spaceBetween: 4,
      slidesPerGroup: 1,
    },

    480: {
      slidesPerView: 1,
      spaceBetween: 4,
    },

    640: {
      slidesPerView: 1,
      spaceBetween: 3,
    },
  };


  itemAplicativos: any[] = [
    {
      title: "Gestão de clientes e equipes",
      type: "gratuitos",
      items: [
        {
          img: "icon-15.svg",
          text: "Clientes",
          body: {
            paragraph:
              "Organize dados dos seus clientes e acompanhe transações com praticidade.",
            beneficios: [
              '  <span class="mark-blue">Cadastro simples:</span> Envio de comprovantes por SMS ou e-mail;',

              '<span class="mark-blue"> Histórico automático:</span> Vinculação de cartões às compras realizadas;',
              '<span class="mark-blue">  Acompanhamento eficiente</span>: Vincule cartões e monitore as transações de cada cliente.',
            ],
            img: "tela1.png",
          },
        },
        {
          img: "icon-2.svg",
          text: "Notas",
          body: {
            paragraph:
              "Adicione notas digitais nos dispositivos Clover e elimine os recados físicos.",
            beneficios: [
              '<span class="mark-blue">Comunicação eficiente:</span> Informações claras e acessíveis em todos os dispositivos;',
              '<span class="mark-blue">Sustentabilidade:</span>  Substitua papéis por notas digitais.',
            ],
          },
        },
        {
          img: "icon-8.svg",
          text: "Turnos",
          body: {
            paragraph:
              "Gerencie horários de trabalho de forma prática e precisa com o App Turnos.",
            beneficios: [
              '<span class="mark-blue"> Registro automático:</span> Horários de entrada e saída detalhados;',

              '<span class="mark-blue">Facilidade para pagamentos:</span> Ideal para estabelecimentos com jornada por hora;',
              '<span class="mark-blue">Otimização de processos:</span> Controle eficiente das equipes.',
            ],
            img: "tela5.png",
          },
        },
        {
          img: "icon-13.svg",
          text: "Gestão de Funcionários",
          body: {
            paragraph:
              "Organize e monitore sua equipe com funcionalidades que garantem eficiência e segurança.",
            beneficios: [
              '<span class="mark-blue">  Criação de perfis:</span> Configure diferentes acessos para cada funcionário;',
              '<span class="mark-blue">Rastreabilidade:</span> Registre todas as ações realizadas no sistema;',
              '<span class="mark-blue">Controle de vendas:</span> Acompanhe o desempenho individual para gestão de comissões;',
              '<span class="mark-blue"> Segurança avançada:</span> Defina permissões específicas por cargo, com senhas e rastreamento.',
            ],
          },
        },
      ],
    },
    {
      title: "Finanças e Pagamentos",
      type: "gratuitos",
      items: [
        {
          img: "icon-fincancas.svg",
          text: "Finanças+",
          body: {
            paragraph:
              "Antecipe seus recebíveis de forma prática e com as melhores condições diretamente pelo App Finanças+.",
            beneficios: [
              ' <span class="mark-blue">Disponibilidade imediata:</span> Veja o valor disponível para antecipação de qualquer adquirente;',
              '<span class="mark-blue">Comparação de taxas:</span> Encontre as condições mais competitivas;',
              '<span class="mark-blue">Fluxo de caixa otimizado:</span> Configure antecipações automáticas e alavanque seu negócio.',
            ],
            img: "tela-financas.png",
          },
        },
        {
          img: "link-de-pagamentos.svg",
          text: "Link de Pagamentos - (Em Breve)",
          body: {
            paragraph: "",
            beneficios: ['<span class="mark-blue"></span>', ,],
          },
          status: "disabled",
        },
        {
          img: "centraliza.svg",
          text: "Centraliza - (Em Breve)",
          body: {
            paragraph: "",
            beneficios: ['<span class="mark-blue"></span>', ,],
          },
          status: "disabled",
        },
        {
          img: "conecta-facil.svg",
          text: "Conecta Fácil - (Em Breve)",
          body: {
            paragraph: "",
            beneficios: ['<span class="mark-blue"></span>', ,],
          },
          status: "disabled",
        },
      ],
    },
    {
      title: "Controle do seu negócio",
      type: "gratuitos",
      items: [
        {
          img: "icon-6.svg",
          text: "Autorizações",
          body: {
            paragraph:
              "Gerencie pré-autorizações com total controle diretamente pelo App.",
            beneficios: [
              '<span class="mark-blue"> Gestão completa:</span> Criação, consulta, confirmação e anulação;',
              '<span class="mark-blue">Praticidade:</span> Centralize o controle de autorizações.',
            ],
          },
        },
        {
          img: "icon-9.svg",
          text: "Transações ",
          body: {
            paragraph:
              "Gerencie suas transações diretamente pelo App com funcionalidades essenciais.",
            beneficios: [
              '<span class="mark-blue">Histórico completo:</span> Listagem detalhada de transações feitas na Clover;',
              '<span class="mark-blue">Flexibilidade:</span> Cancelamento, reimpressão e envio de comprovantes;',
              '<span class="mark-blue"> Praticidade:</span> Gestão rápida e eficiente de vendas realizadas.',
            ],
            img: "tela6.png",
          },
        },
        {
          img: "icon-10.svg",
          text: "Vendas",
          body: {
            paragraph:
              "Realize vendas com todas as formas de pagamento habilitadas e aceite mais clientes.",
            beneficios: [
              '<span class="mark-blue"> Capilaridade máxima:</span> Aceite todas as formas de pagamento disponíveis via SiTef;',
              '<span class="mark-blue">Simplicidade:</span> Todas as opções de pagamento disponíveis no App.',
            ],
            img: "tela7.png",
          },
        },
        {
          img: "icon-12.svg",
          text: "Relatórios",
          body: {
            paragraph:
              "Simplifique sua gestão com relatórios detalhados e acompanhamento eficiente de transações e equipes.",
            beneficios: [
              '<span class="mark-blue">  Análises completas:</span> Relatórios por período, funcionário e fechamento de caixa;',
              '<span class="mark-blue">Fechamento de caixa: </span>Visualize o fechamento de caixa de todas as suas máquinas;',
              '<span class="mark-blue"> Comissões sob controle: </span>Monitoramento de vendas por funcionário.',
            ],
            img: "tela8.png",
          },
        },
        {
          img: "fluxo-de-caixa.svg",
          text: "Fluxo de Caixa",
          body: {
            paragraph: "",
            beneficios: [""],
            img: "",
          },
          status: "disabled-active",
        },
      ],
    },
    {
      title: "Suporte a Clover",
      type: "gratuitos",
      items: [
        {
          img: "icon-1.svg",
          text: "Suporte",
          body: {
            paragraph:
              "Resolva problemas técnicos e solicite manutenções do seu dispositivo de forma rápida e prática.",
            beneficios: [
              ' <span class="mark-blue">Solicitação fácil:</span> Atendimento direto pelo App;',
              '<span class="mark-blue">Agilidade:</span> Soluções rápidas para garantir o funcionamento do seu negócio.',
            ],
          },
        },
        {
          img: "icon-7.svg",
          text: "Impressoras",
          body: {
            paragraph:
              "Configure e ajuste suas impressoras de forma simples e eficiente.",
            beneficios: [
              '<span class="mark-blue">Ajustes rápidos:</span> Controle total das impressoras conectadas;',
              '<span class="mark-blue">Facilidade:</span> Personalize as configurações conforme sua necessidade.',
            ],
          },
        },

        {
          img: "icon-11.svg",
          text: "Ajuda",
          body: {
            paragraph:
              "Encontre respostas rápidas e úteis para suas dúvidas sobre o terminal Clover.",
            beneficios: [
              '<span class="mark-blue"> Suporte completo: </span>Informações práticas e tutoriais;',
              '<span class="mark-blue">Autoatendimento:</span> Resolva questões sem precisar de ajuda externa.',
            ],
          },
        },
      ],
    },

    {
      title: "Outros Apps para facilitar seu dia a dia",
      type: "comerciais",
      items: [
        {
          img: "icon-14.svg",
          text: "App Market",
          body: {
            paragraph:
              "Personalize sua experiência com a loja de aplicativos Clover, feita para simplificar sua operação.",
            beneficios: [
              '<span class="mark-blue"> Variedade:</span> Apps para gerenciamento, estoque, relatórios, e mais;',
              '<span class="mark-blue">Setores específicos:</span> Categorias como e-commerce, alimentação, eventos e serviços;',
              '<span class="mark-blue">Facilidade:</span> Tudo que seu negócio precisa em um único lugar.',
            ],
          },
        },
      ],
    },
  ];
  itemAplicativosFlattened: any[] = [];
  activeModalItem: any = null;
  element?: any
  activeTab: string = "gratuitos";

  setActiveTab(tab: string) {
    this.activeTab = tab;
    this.activeModalItem = null;
  }
  get aplicativosComercias() {
    return this.itemAplicativos.filter((c) => c.type === "comerciais");
  }
  get aplicativosGratuitos() {
    return this.itemAplicativos.filter((c) => c.type === "gratuitos");
  }
  setActiveModal(item: any) {
    const elementPosition = this.element.getBoundingClientRect().top + window.scrollY;
    const offset = 70; // Ajuste este valor para definir a posição final desejada
  
    window.scrollTo({ top: elementPosition - offset, behavior: 'smooth' });

    // Se o item já está ativo, fecha a modal, senão abre a nova modal
    this.activeModalItem = this.activeModalItem === item ? null : item;
  }

  ngOnInit(): void {
    window.scrollTo(0, 0);
    this.element = document.getElementById('meuElemento');

    this.tituloAbaService.setTitle("azulzinha apresenta Clover");
    this.tituloAbaService.setMeta(
      "description",
      "Transforme sua operação e encante seus clientes com a praticidade e tecnologia de ponta dos dispositivos Clover. Clique e descubra!"
    );

    this.itemAplicativosFlattened = this.itemAplicativos.flatMap(
      (categoria) => categoria.items
    );
  }
}
